(function () {
  'use strict';

  const windowSize = 4;

  function windowBounds(total, selected) {
    const start = Math.max(0, Math.min(selected, total - windowSize));
    return { start: start, end: Math.min(total, start + windowSize) };
  }

  function init(document) {
    const view = document.defaultView;
    document.querySelectorAll('[data-nspire-pilot] [data-pilot-gallery]').forEach(function (gallery) {
      if (gallery.__pilotGalleryWindow) return;
      const strip = gallery.querySelector('[data-gallery-window]');
      const track = gallery.querySelector('[data-gallery-track]');
      if (!strip || !track) return;
      const thumbs = Array.from(strip.querySelectorAll('[data-gallery-thumb]'));
      if (!thumbs.length) return;

      // The main gallery owns index, aria-current and scrolling. This controller
      // only follows that selection; it never scrolls either gallery or page.
      let frame = null;
      function render() {
        frame = null;
        if (!gallery.isConnected) return destroy();
        const selected = Math.max(0, thumbs.findIndex(function (thumb) {
          return thumb.getAttribute('aria-current') === 'true';
        }));
        const bounds = windowBounds(thumbs.length, selected);
        const focused = document.activeElement;
        let restoreFocus = false;
        thumbs.forEach(function (thumb, index) {
          const hidden = index < bounds.start || index >= bounds.end;
          if (hidden && thumb === focused) restoreFocus = true;
          if (thumb.hidden !== hidden) thumb.hidden = hidden;
        });
        strip.dataset.galleryWindowStart = String(bounds.start);
        if (restoreFocus) thumbs[selected].focus({ preventScroll: true });
      }

      function schedule() {
        if (frame === null) frame = view.requestAnimationFrame(render);
      }

      // Observing only aria-current avoids reacting to our own hidden changes.
      // It also supports a main-gallery selection made without a scroll event.
      const observer = new view.MutationObserver(schedule);
      observer.observe(strip, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
      track.addEventListener('scroll', schedule, { passive: true });
      track.addEventListener('scrollend', schedule, { passive: true });
      view.addEventListener('resize', schedule, { passive: true });

      function unload(event) {
        if (event.target === gallery || event.target.contains(gallery)) destroy();
      }
      function destroy() {
        observer.disconnect();
        if (frame !== null) view.cancelAnimationFrame(frame);
        track.removeEventListener('scroll', schedule);
        track.removeEventListener('scrollend', schedule);
        view.removeEventListener('resize', schedule);
        document.removeEventListener('shopify:section:unload', unload);
        delete gallery.__pilotGalleryWindow;
      }
      document.addEventListener('shopify:section:unload', unload);
      gallery.__pilotGalleryWindow = { destroy: destroy };
      render();
    });
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { windowBounds: windowBounds, init: init };
  if (typeof document !== 'undefined') {
    const boot = function () { init(document); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
    else boot();
    document.addEventListener('shopify:section:load', boot);
  }
})();
